import { Map } from 'immutable';

import {
  VALIDATION_BIOMETRY_FETCH_REQUEST,
  VALIDATION_BIOMETRY_FETCH_FAILURE,
  VALIDATION_BIOMETRY_FETCH_SUCCESS,
} from './action';

const initialState = Map({
  type: '',
  payload: {},
});

function reducer(state = initialState, action) {
  const { type } = action;

  if (type === VALIDATION_BIOMETRY_FETCH_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => true)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], {});
  }

  if (type === VALIDATION_BIOMETRY_FETCH_FAILURE) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], payload);
  }

  if (type === VALIDATION_BIOMETRY_FETCH_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => true)
      .setIn(['payload'], payload);
  }

  return state;
}

export default reducer;
